import React from 'react';
import PropTypes from 'prop-types';
import { CalendarMonth } from '@mui/icons-material';
import { formatEvaluationInterval } from '../../utils/performanceMonth';

const EvaluationIntervalBadge = ({
  startYearMonth,
  endYearMonth,
  loading,
  compact
}) => {
  const isDarkMode = document?.body?.classList.contains('dark');
  const intervalLabel = formatEvaluationInterval(startYearMonth, endYearMonth);

  if (!loading && !intervalLabel) {
    return null;
  }

  return (
    <div
      className={`border ${compact ? 'mb-3 rounded-xl px-2.5 py-2' : 'mb-4 rounded-2xl px-3 py-2'} ${
        isDarkMode
          ? 'border-slate-700 bg-slate-800/70'
          : 'border-slate-200 bg-slate-50'
      }`}
    >
      <div className={`flex items-start ${compact ? 'gap-2.5' : 'gap-3'}`}>
        <div
          className={`mt-0.5 ${compact ? 'rounded-lg p-1.5' : 'rounded-xl p-2'} ${
            isDarkMode
              ? 'bg-slate-700 text-slate-200'
              : 'bg-white text-slate-600'
          }`}
        >
          <CalendarMonth fontSize="small" />
        </div>
        <div className="min-w-0">
          <p
            className={`font-semibold uppercase text-slate-500 dark:text-slate-400 ${
              compact
                ? 'text-[10px] tracking-[0.14em]'
                : 'text-[11px] tracking-[0.18em]'
            }`}
          >
            Evaluation Interval
          </p>
          {loading ? (
            <div
              className={`rounded animate-pulse ${
                compact ? 'mt-1.5 h-3.5 w-32' : 'mt-2 h-4 w-40'
              } ${isDarkMode ? 'bg-slate-700' : 'bg-slate-200'}`}
            />
          ) : (
            <p
              className={`font-medium text-slate-700 dark:text-slate-200 ${
                compact ? 'mt-0.5 text-xs leading-5' : 'mt-1 text-sm'
              }`}
            >
              Based on activity from {intervalLabel}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

EvaluationIntervalBadge.propTypes = {
  startYearMonth: PropTypes.string,
  endYearMonth: PropTypes.string,
  loading: PropTypes.bool,
  compact: PropTypes.bool
};

EvaluationIntervalBadge.defaultProps = {
  startYearMonth: '',
  endYearMonth: '',
  loading: false,
  compact: false
};

export default EvaluationIntervalBadge;
